import './loader.css';

function Loader() {
  return (
    <>

      <div className='loader'>
        <div className='first_container'>
          <div className='second_container'>
            <div className='third_container'>

            </div>
          </div>
        </div>




      </div>
    </>
  );
}

export default Loader;
